import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Third Party Script",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-third-party-script",
    args: {
        src: "",
        type: "text/javascript",
        integrity: "",
        crossOrigin: "",
        defer: false,
        async: false,
        scriptId: "",
        noModule: false,
        referrerPolicy: "",
        allowedLocales: "",
        cookieConsentRequired: false,
    },
    argTypes: {
        src: { control: "text" },
        type: { control: "text" },
        integrity: { control: "text" },
        crossOrigin: { control: "text" },
        defer: { control: "boolean" },
        async: { control: "boolean" },
        scriptId: { control: "text" },
        noModule: { control: "boolean" },
        referrerPolicy: { control: "text" },
        allowedLocales: { control: "text" },
        cookieConsentRequired: { control: "boolean" },
    },
};

const Template = ({
    src,
    type,
    integrity,
    crossOrigin,
    defer,
    async,
    scriptId,
    noModule,
    referrerPolicy,
    allowedLocales,
    cookieConsentRequired,
}) =>
    html`<ux-iws-third-party-script
        src="${src}"
        type="${type}"
        integrity="${integrity}"
        cross-origin="${crossOrigin}"
        ?defer="${defer}"
        ?async="${async}"
        script-id="${scriptId}"
        ?no-module="${noModule}"
        referrer-policy="${referrerPolicy}"
        allowed-locales="${allowedLocales}"
        ?cookie-consent-required="${cookieConsentRequired}"
    ></ux-iws-third-party-script>`;

export const Default = Template.bind({});
Default.args = {
    src: "https://cdn.trumpf.com/mf-service-calls/1.9.9/dist/esm/service-calls.js",
    allowedLocales: "en,de-DE",
    async: true,
    cookieConsentRequired: true,
    type: "module",
};
